
const NEXT_PATH_KEY = 'afterAuthRedirectPath'

const ignoredPaths = ['/']

export const saveCurrentState = () => {
  const currentPath = window.location.pathname + window.location.search
  localStorage.setItem(NEXT_PATH_KEY, currentPath)
}

export const consumeNextState = () => {
  const nextPath = localStorage.getItem(NEXT_PATH_KEY)
  localStorage.removeItem(NEXT_PATH_KEY)
  if (!nextPath || ignoredPaths.includes(nextPath)) return null
  return nextPath
}
